import { fetchAuthSession } from 'aws-amplify/auth';
import { BACKEND_AGENTS_API } from '../env';

/**
 * Genera un título corto para un chat a partir del primer mensaje.
 *
 * Antes esto llamaba a Bedrock (InvokeModel) directamente desde el
 * navegador con credenciales de un Cognito Identity Pool. Ahora pasa por
 * una Lambda (whisperbi-agent-management) que hace la llamada a Bedrock
 * del lado del servidor — el frontend nunca debe invocar Bedrock ni
 * DynamoDB directamente.
 *
 * @param {string} texttoSummarize
 * @returns {Promise<string>} El título generado.
 */
const SummarizeTextWithClaude = async (texttoSummarize) => {
  const session = await fetchAuthSession();
  const idToken = session.tokens?.idToken?.toString();

  const response = await fetch(`${BACKEND_AGENTS_API}/agent/summarize-title`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${idToken}`
    },
    body: JSON.stringify({ text: texttoSummarize })
  });

  if (!response.ok) {
    const errorBody = await response.json().catch(() => ({}));
    throw new Error(errorBody.error || `HTTP ${response.status}: no se pudo generar el título del chat`);
  }

  const data = await response.json();
  return data.title;
};

export default SummarizeTextWithClaude;
